import { ActionType } from '~/lib/api/account-linking/types';

export const isLinkOrInstallAction = (action: ActionType) => {
  return action === 'Link' || action === 'Install';
};
